<template>
  <section>
    <gs-header title="Thêm mới chặn tuyến đường" :breadcrumbs="[
      { title: 'Quản lý chặn tuyến đường', route: { name: 'blocks' } }
    ]">
    </gs-header>
    <div class="padding-sm-all padding-lg-bottom">
      <el-form label-position="top" class="margin-top" :rules="rules" ref="create-block-form" :model="localBlock"
        label-width="150px" @submit.prevent.native="validatorBeforeSubmit">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="8">
            <el-form-item label="Chọn bảng giá" class="is-required">
              <el-select class="display-block" v-model="suggettionPriceTable" filterable remote
                placeholder="Nhập tên bảng giá" :remote-method="selectPriceTable" :loading="fetchPriceTable"
                @change="selectSuggettionPriceTable">
                <el-option v-for="(item, index) in listPriceTable" :key="index" :value="item">
                  <span class="pull-left text-gray"><i class="fa fa-user"></i>&nbsp;{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Chọn tỉnh thành" class="is-required">
              <el-select :disabled="!localBlock.price_table_id" @change="getDistricts" class="display-block"
                v-model="localBlock.city_id" filterable placeholder="Chọn tỉnh thành">
                <el-option v-for="(city, index) in blockCities" :label="city.name" :value="city.id" :key="index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Chọn quận huyện">
              <el-select :disabled="!localBlock.city_id" class="display-block" v-model="localBlock.district_id"
                @change="generateData" filterable placeholder="Chọn quận huyện">
                <el-option v-for="(district, index) in districts" :label="district.name" :value="district.id"
                  :key="index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="10" class="remove-margin" v-if="localBlock.price_table_id">
        <el-col :span="8" class="padding-all">
          <h3>Thông tin bảng giá: </h3>
          <p>Tên bảng giá: {{ priceTable.name }}</p>
          <p>Hãng vận chuyển: {{ priceTable.carrier.data.name }} </p>
          <p>Dịch vụ: {{ priceTable.service.data.name }} </p>
          <p>Thành phố đi: {{ priceTable.city_from.data.name }} </p>
          <p>Vùng miền đến: {{ priceTable.region_to.data.name }} </p>
        </el-col>
        <el-col :span="16">
          <h3>
            Thông chặn tuyến đường
            <button :disabled="!localBlock.city_id" class="ui blue basic mini button pull-right" type="button"
              @click="validatorBeforeSubmit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
          </h3>
          <el-table :data="[{}]" :show-header="false" row-class-name="row-like-header">
            <el-table-column>
              <template slot-scope="scope">
                Chọn/bỏ chọn tất cả
              </template>
            </el-table-column>
            <el-table-column label="Chiều đi" width="100">
              <template slot-scope="scope">
                <div class="text-center">
                  <el-checkbox :indeterminate="isIndeterminateFrom" v-model="checkAllFrom"
                    @change="handleCheckAllFrom"></el-checkbox>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Chiều đến" width="100">
              <template slot-scope="scope">
                <div class="text-center">
                  <el-checkbox :indeterminate="isIndeterminateTo" v-model="checkAllTo"
                    @change="handleCheckAllTo"></el-checkbox>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="dataBlocks" border style="width: 100%">
            <el-table-column label="Điểm giao/ lấy">
              <template slot-scope="scope">
                {{ scope.row.district }}
              </template>
            </el-table-column>
            <el-table-column label="Chiều đi" width="100">
              <template slot-scope="scope">
                <div class="text-center">
                  <el-checkbox v-model="scope.row.from"></el-checkbox>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Chiều đến" width="100">
              <template slot-scope="scope">
                <div class="text-center">
                  <el-checkbox v-model="scope.row.to"></el-checkbox>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <button :disabled="!localBlock.city_id" class="ui blue basic mini margin-top button pull-right" type="button"
            @click="validatorBeforeSubmit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
        </el-col>
      </el-row>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getAllPriceTables } from 'src/api/pricetable'
import { forEach, findIndex, head } from 'lodash'
import { createBlock, getAllBlock } from 'src/api/block'
export default {
  name: 'NewBlock',
  computed: {
    ...mapGetters('priceTable', ['priceTable']),
    ...mapGetters('district', ['districts']),
    ...mapGetters('city', ['blockCities'])
  },
  data() {
    return {
      localBlock: {
        price_table_id: 0,
        city_id: undefined,
        district_id: undefined,
        limit: -1
      },
      suggettionPriceTable: {},
      fetchPriceTable: false,
      listPriceTable: [],
      rules: {},
      dataBlocks: [],
      fetchData: true,
      checkAllTo: false,
      isIndeterminateTo: true,
      checkAllFrom: false,
      isIndeterminateFrom: true
    }
  },
  methods: {
    ...mapActions('priceTable', ['setPriceTable']),
    ...mapActions('district', ['getDistrictByCityId']),
    ...mapActions('city', ['getBlockCities']),
    validatorBeforeSubmit() {
      createBlock(this.dataBlocks).then(response => {
        switch (response.code) {
          case 200:
            this.$store.dispatch('showNotify', {
              title: 'Thêm mới thành công',
              body: 'Tạo mới chặn tuyến đường thành công',
              type: 'success'
            })
            this.reloadGsTableAfterRedirect({ name: 'blocks' }, 'blocks')
            this.toggleLoadding(false)
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              body: message,
              type: 'warning'
            })
            this.toggleLoadding(false)
            break
          default:
            this.$store.dispatch('showNotify', {
              title: 'Thêm mới thất bại',
              body: 'Tạo chặn tuyến đường thất bại vui lòng kiểm tra lại thông tin',
              type: 'danger'
            })
            this.toggleLoadding(false)
        }
      })
    },
    selectPriceTable(q) {
      if (q) {
        this.fetchPriceTable = true
        getAllPriceTables({ limit: 20, q: q, include: 'carrier,service,city_from,region_to' }).then(response => {
          if (response.code === 200) {
            this.listPriceTable = response.data
            this.fetchPriceTable = false
          }
        })
      }
    },
    selectSuggettionPriceTable() {
      this.setPriceTable(this.suggettionPriceTable)
      this.localBlock.price_table_id = this.suggettionPriceTable.id
      this.getBlockCities({ limit: -1, price_table_id: this.suggettionPriceTable.id })
      this.listPriceTable = []
      this.dataBlocks = []
    },
    getDistricts() {
      this.localBlock.district_id = ''
      this.getDistrictByCityId({ city_id: this.localBlock.city_id, limit: -1, sort: 'name:1' })
    },
    generateData() {
      this.checkAllTo = false
      this.isIndeterminateTo = true
      this.checkAllFrom = false
      this.isIndeterminateFrom = true
      this.toggleLoadding(true)
      getAllBlock(this.localBlock).then(response => {
        if (response.code === 200) {
          let oldBlocks = response.data
          this.toggleLoadding(false)
          this.dataBlocks = []
          if (this.localBlock.district_id) {
            let district = this.districts[findIndex(this.districts, { id: this.localBlock.district_id })]
            if (findIndex(oldBlocks, { district_id: this.localBlock.district_id }) > -1) {
              this.dataBlocks.push({
                district_id: district.id,
                district: district.fullname,
                price_table_id: this.priceTable.id,
                from: !!oldBlocks[findIndex(oldBlocks, { district_id: this.localBlock.district_id })].from,
                to: !!oldBlocks[findIndex(oldBlocks, { district_id: this.localBlock.district_id })].to
              })
            } else {
              this.dataBlocks.push({
                district_id: district.id,
                district: district.fullname,
                price_table_id: this.priceTable.id,
                from: false,
                to: false
              })
            }
          } else {
            forEach(this.districts, district => {
              if (findIndex(oldBlocks, { district_id: district.id }) > -1) {
                this.dataBlocks.push({
                  district_id: district.id,
                  district: district.fullname,
                  price_table_id: this.priceTable.id,
                  from: !!oldBlocks[findIndex(oldBlocks, { district_id: district.id })].from,
                  to: !!oldBlocks[findIndex(oldBlocks, { district_id: district.id })].to
                })
              } else {
                this.dataBlocks.push({
                  district_id: district.id,
                  district: district.fullname,
                  price_table_id: this.priceTable.id,
                  from: false,
                  to: false
                })
              }
            })
            if (this.price_table_id && this.city_id) {
              this.fetchData = false
            }
          }
        } else {
          this.toggleLoadding(false)
          this.dataBlocks = []
        }
      })
    },
    handleCheckAllTo() {
      forEach(this.dataBlocks, (value, key) => {
        this.dataBlocks[key]['to'] = this.checkAllTo
      })
      this.isIndeterminateTo = false
    },
    handleCheckAllFrom() {
      forEach(this.dataBlocks, (value, key) => {
        this.dataBlocks[key]['from'] = this.checkAllFrom
      })
      this.isIndeterminateFrom = false
    }
  },
  mounted() {
  },
  watch: {
    localBlock: {
      handler: function (value) {
        if (
          value.city_id
        ) {
          this.fetchData = true
        }
      },
      deep: true
    },
    districts(value) {
      if (this.fetchData) {
        this.generateData()
      }
    }
  }
}
</script>

<style lang="css" scoped>
.border-right {
  border-right: 1px solid #dfe6ec;
}
</style>



// WEBPACK FOOTER //
// NewBlock.vue?626510d3